import t from './story13.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,

  prose: [
    // Run 1 — the phone assay and its mineral inventory.
    [{ text: t.s1P1 }, { text: t.s1P2 }, { text: t.s1P3 }],
    // Run 2 — tungsten and cobalt’s connection to conflict.
    [{ text: t.s2P1 }, { text: t.s2P2 }, { text: t.s2P3 }],
    // Run 3 — China’s control of tungsten and cobalt supply chains.
    [
      { title: t.s3Title, text: t.s3P1 },
      { text: t.s3P2 },
      { text: t.s3P3 },
      { text: t.s3P4 },
      { text: t.s3P5 },
    ],
    // Run 4 — geopolitical competition for mineral supply.
    [{ title: t.s4Title, text: t.s4P1 }, { text: t.s4P2 }],
    [{ text: t.s4P3 }, { text: t.s4P4 }, { text: t.s4P5 }],
    // Run 5 — the consequences of mineral diplomacy.
    [{ title: t.s5Title, text: t.s5P1 }, { text: t.s5P2 }, { text: t.s5P3 }],
  ],

  captions: [
    // 01 — hero, Trump with coal and energy workers.
    [t.f1P1],
    // 02 — cobalt and copper mining in Kolwezi.
    [t.f2P1],
    // 03 — Greenland protest in Nuuk.
    [t.f3P1],
    // 04 — HIV test in Sikwaazwa village.
    [t.f4P1],
  ],

  quotes: [{ text: t.q1 }, { text: t.q2 }],
} as const
